import React, { useState, useEffect } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import api from '../../functions/api';
import '../../styles/Forms.css'
import { useToast } from '../ToastProvider';
import { ReactComponent as IconClose } from "../../assets/icons/icon-close.svg";


const EditRolForm = ({ data, show, handleClose, onUpdated }) => {
  const initialForm = {
    id_rol: '',
    nombre: '',
    descripcion: ''
  };

  /* ---------- formData ---------- */
  const [formData, setFormData] = useState(initialForm);
  const resetForm = () => setFormData(initialForm);

  const { showError } = useToast();
  useEffect(() => {
    if (data) {
      // Copiamos los campos de la licencia en el estado
      setFormData({ ...data });
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('access_token');
      const response = await api.post('/auth/roles/edit', formData, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      // Notificamos al padre que se creó el cliente
      onUpdated(response.data);
      // Cerramos el modal
      handleClose();
    } catch (error) {
      showError('Error al actualizar el rol:', error);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} onExited={resetForm} backdrop="static" keyboard={false} centered dialogClassName="basic-modal">
      <Modal.Header closeButton={false}>
        <Modal.Title>Actualizar Información de Rol</Modal.Title>
        <button
          type="button"
          onClick={handleClose}
          aria-label="Cerrar modal"
          className="btn-reset ms-auto"   // define estilo a tu gusto
        >
          <IconClose className="mc-link__icon secondary" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Nombre</Form.Label>
            <Form.Control
              type="text"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Descripción</Form.Label>
            <Form.Control
              type="text"
              name="descripcion"
              value={formData.descripcion}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <div className="d-grid">
            <Button variant="primary" type="submit" className='btn-dark'>
              Actualizar Rol
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default EditRolForm;
